// react
import React, { useRef, useState } from "react";
// form
import { useForm } from 'react-hook-form';
import { SendCv } from "../../../../services/photographer/auth/sendCv.tsx";
// react query
import { useMutation } from "@tanstack/react-query";
// toast
import { toastOptions } from "../../../../features/toast/toast.tsx";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// error
import { onError } from "../../../../features/error/error.tsx";
// calendar
// @ts-ignore
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
// map
import Mapir from "mapir-react-component";
import 'mapbox-gl/dist/mapbox-gl.css';
import axios from "axios";

const Map = Mapir.setToken({
    transformRequest: url => {
        return {
            url: url, headers: {
                "x-api-key": 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjllMmFiMjE4MjEzMjI4YmIyMTM5OWFlNjgyNTRkN2Y3NThmYWU3NGRmZGQ2NjViN2RhZGVmMWIxOWFhODg0YTMzMDVlZGUxOWUyOTVjYTEyIn0.eyJhdWQiOiIyNDM2NiIsImp0aSI6IjllMmFiMjE4MjEzMjI4YmIyMTM5OWFlNjgyNTRkN2Y3NThmYWU3NGRmZGQ2NjViN2RhZGVmMWIxOWFhODg0YTMzMDVlZGUxOWUyOTVjYTEyIiwiaWF0IjoxNjk2MzcyNTkyLCJuYmYiOjE2OTYzNzI1OTIsImV4cCI6MTY5ODg3ODE5Miwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oEE6bnb9YLzTdsh0w_oMXY6trPg3FWm1pN1OfGfnbNAWsu3ODkyI3pfHFDfZAPJ2NHhixT7UKxeYYB-9YOmJIutiywx1CUZHdABaNv733Y1R0q-9Sx-tywHjFus5PcUgLqH4LMLMQvzduLxpVV44eJh29AKzLYBACsnUCFygxfh1zti5u7VdnKhmBMf8t6_tfSVzaUIaf0uBLeyQwJH56K7nyzHzY0wsIr3zZ8f7PXJt4vvJ74dbW05rDwVjBkXoT4EpwsCH6udlt1_nTQVER-hr8IPxs1KFHl4IG63SamYKzFROo48MMCcQT17paPgSa-P-gDeI6Amr3CvZP5_0SA', //Mapir api key
                "Mapir-SDK": "reactjs"
            }
        };
    }
});

const Cv = () => {
    const { register, handleSubmit }: any = useForm<any>();
    const [value, setValue] = useState<any>()
    const [coord] = useState([51.42, 35.72]);
    const [address, setAdress] = useState<any>();
    const [latitude, setLatitude] = useState<number | any>()
    const [longitude, setLongitude] = useState<number | any>()
    const markerRef = useRef<HTMLDivElement | null>(null);
    const reverseFunction = async (map, e) => {
        let configs = {
            headers: {
                "Content-Type": "application/json",
                "x-api-key": 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjllMmFiMjE4MjEzMjI4YmIyMTM5OWFlNjgyNTRkN2Y3NThmYWU3NGRmZGQ2NjViN2RhZGVmMWIxOWFhODg0YTMzMDVlZGUxOWUyOTVjYTEyIn0.eyJhdWQiOiIyNDM2NiIsImp0aSI6IjllMmFiMjE4MjEzMjI4YmIyMTM5OWFlNjgyNTRkN2Y3NThmYWU3NGRmZGQ2NjViN2RhZGVmMWIxOWFhODg0YTMzMDVlZGUxOWUyOTVjYTEyIiwiaWF0IjoxNjk2MzcyNTkyLCJuYmYiOjE2OTYzNzI1OTIsImV4cCI6MTY5ODg3ODE5Miwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oEE6bnb9YLzTdsh0w_oMXY6trPg3FWm1pN1OfGfnbNAWsu3ODkyI3pfHFDfZAPJ2NHhixT7UKxeYYB-9YOmJIutiywx1CUZHdABaNv733Y1R0q-9Sx-tywHjFus5PcUgLqH4LMLMQvzduLxpVV44eJh29AKzLYBACsnUCFygxfh1zti5u7VdnKhmBMf8t6_tfSVzaUIaf0uBLeyQwJH56K7nyzHzY0wsIr3zZ8f7PXJt4vvJ74dbW05rDwVjBkXoT4EpwsCH6udlt1_nTQVER-hr8IPxs1KFHl4IG63SamYKzFROo48MMCcQT17paPgSa-P-gDeI6Amr3CvZP5_0SA'
            }
        }
        await axios.get(`https://map.ir/reverse/no?lat=${e.lngLat.lat}&lon=${e.lngLat.lng}`, configs)
            .then((response: any) => {
                setAdress(response.data.address)
                setLongitude(response.data.geom.coordinates[0])
                setLatitude(response.data.geom.coordinates[1])
            })
        if (markerRef.current) {
            markerRef.current.style.left = `${e.point.x}px`; // تنظیم موقعیت X
            markerRef.current.style.top = `${e.point.y}px`; // تنظیم موقعیت Y
        }
    }
    const mutation = useMutation({
        mutationFn: SendCv,
        onSuccess: data => {
            toast.success('با موفقیت اطلاعات شما ارسال شد', toastOptions);
        },
        onError: (error: any) => {
            const errors: any = error.response.data?.message;
            if (errors) {
                for (const [, messages] of Object.entries(errors)) {
                    (messages as string[]).forEach((message) => {
                        toast.error(message, toastOptions);
                    });
                }
            }
        },
    });

    function handleChange(value) {
        let formattedDate = value?.format("YYYY/MM/DD");
        formattedDate = formattedDate.replace(/\//g, "-");
        const persianToEnglish = (str) => str.replace(/[۰-۹]/g, (char) => String.fromCharCode(char.charCodeAt(0) - 1728));
        const finalDate = persianToEnglish(formattedDate);
        setValue(finalDate);
    }
    const onSubmit = (data: any) => {
        // eslint-disable-next-line no-mixed-operators
        if (!value || value === null || value === '' && address === '' || address === null) {
            toast.error('تاریخ تولد و آدرس را به درستی وارد نمایید', toastOptions)
        }
        else {
            let dataToForm: any = new FormData();
            dataToForm.append('full_name', data.full_name)
            dataToForm.append('cellphone', data.cellphone)
            dataToForm.append('national_code', data.national_code)
            dataToForm.append('address', data.address)
            dataToForm.append('longitude', longitude);
            dataToForm.append('latitude', latitude);
            dataToForm.append('date_of_birth', value);
            dataToForm.append('resume', data.resume[0]);
            mutation.mutate(dataToForm)
        }
    };
    return (
        <>
            <section className='modal fade' id='cv'>
                <div className='modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable'>
                    <div className='modal-content rounded rounded-4'>
                        <div className='modal-body'>
                            <div className="content p-4 pt-0">
                                <div className="texts text-center">
                                    <p className="h3 fw-bold text-center">ارسال رزومه</p>
                                    <p className="text mt-3 text-center mb-0">اطلاعات مد نظر را وارد کنید</p>
                                </div>
                                <form onSubmit={handleSubmit(onSubmit, onError)}>
                                    <div className="row gy-4 mt-2">
                                        <div className="col-md-6">
                                            <fieldset className='form-floating'>
                                                <input
                                                    type='text'
                                                    placeholder='نام , نام خانوادگی'
                                                    className='form-control'
                                                    {...register('full_name', { required: 'فیلد نام و نام خانوادگی الزامی است' })}
                                                />
                                                <label className='form-label'>
                                                    نام و نام خانوادگی
                                                </label>
                                            </fieldset>
                                        </div>
                                        <div className="col-md-6">
                                            <fieldset className='form-floating'>
                                                <input
                                                    type='tel'
                                                    placeholder='تلفن همراه'
                                                    className='form-control'
                                                    {...register('cellphone', { required: 'فیلد تلفن همراه الزامی است' })}
                                                />
                                                <label className='form-label'>
                                                    تلفن همراه
                                                </label>
                                            </fieldset>
                                        </div>
                                        <div className="col-md-6">
                                            <fieldset className='form-floating'>
                                                <input
                                                    type='tel'
                                                    placeholder='کدملی'
                                                    className='form-control'
                                                    {...register('national_code', { required: 'فیلد کدملی الزامی است' })}
                                                />
                                                <label className='form-label'>
                                                    کدملی
                                                </label>
                                            </fieldset>
                                        </div>
                                        <div className="col-md-6">
                                            <fieldset className="form-floating">
                                                <DatePicker
                                                    value={value}
                                                    placeholder={'تاریخ تولد'}
                                                    calendar={persian}
                                                    locale={persian_fa}
                                                    onChange={handleChange}
                                                />
                                            </fieldset>
                                        </div>
                                        <div className="col-md-6 position-relative">
                                            <Mapir center={coord} Map={Map} onClick={reverseFunction}></Mapir>
                                            <div ref={markerRef} className="marker"></div>
                                        </div>
                                        <div className="col-md-6">
                                            <fieldset className='form-floating'>
                                                <textarea
                                                    placeholder='آدرس'
                                                    className='form-control'
                                                    value={address}
                                                />
                                                <label className='form-label'>
                                                    آدرس
                                                </label>
                                            </fieldset>
                                        </div>
                                        <div className="col-md-12">
                                            <fieldset className="form-floating">
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    placeholder="رزومه"
                                                    {...register('resume', { required: 'فیلد رزومه الزامی است' })}
                                                />
                                                <label >رزومه</label>
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-end">
                                        <button disabled={mutation.isPending} className='btn btn-outline-primary mt-4'>
                                            {mutation.isPending ? 'در حال ارسال...' : 'ارسال رزومه'}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default Cv;